import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageService } from '../../services/language.service';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

    constructor(private languageService: LanguageService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const currentLanguage = this.languageService.getCurrentLanguage();

        const languageRequest = request.clone({
            setHeaders: {
                'Accept-Language': currentLanguage
            }
        });

        return next.handle(languageRequest);
    }
}